<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" :label="$t('ROLES.Name')" v-model="roleData.name" name="name" />
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <!-- <vs-input class="w-full mt-4" label="Responde para" v-model="roleData.respond_to" type="text" v-validate="'required'" name="email" /> -->
        <div class="mt-4">
          <label class="vs-input--label">{{ $t('ROLES.respondTo') }}</label>
          <v-select v-model="roleData.respond_to" label="name" :clearable="false" :options="selectOptions.rolesOptions" name="can_view" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <!-- <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <label class="vs-input--label">Pode atribuir registros à</label>
          <v-select v-model="roleData.canAssignValue" label="label" :clearable="false" :options="canAssignOptions" name="can_view" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
        </div>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <label class="vs-input--label">Pode visualizar registros de</label>
          <v-select v-model="roleData.canViewValue" :clearable="false" :options="canViewOptions" name="can_assign" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
        </div>
      </div> -->
      <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <label class="vs-input--label">{{ $t('ROLES.connectionStartTime') }}</label>
          <flat-pickr style="width: 100%;" :config="configdateTimePicker" v-model="roleData.connectionStartTime" :placeholder="$t('ROLES.connectionStartTime')" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <label class="vs-input--label">{{ $t('ROLES.connectionEndTime') }}</label>
          <flat-pickr style="width: 100%;" :config="configdateTimePicker" v-model="roleData.connectionEndTime" :placeholder="$t('ROLES.connectionEndTime')" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <label class="vs-input--label">{{ $t('ROLES.maxSessionsPerUser') }}</label>
          <vs-input-number min="0" v-model="roleData.maxUserSimultaneousSessions" style="width: 30%;"/>
        </div>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <label class="vs-input--label">{{ $t('ROLES.maxSessionsPerRole') }}</label>
          <vs-input-number min="0" v-model="roleData.maxRoleSessions" style="width: 30%;"/>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <!-- <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Máximo de sessões simultâneas por usuário" v-model="roleData.maxUserSimultaneousSessions" type="text" v-validate="'required'" name="email" placeholder="0" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div> -->
      <!-- <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Máximo de sessões por cargo" v-model="roleData.maxRoleSessions" type="text" v-validate="'required'" name="text" placeholder="0" />
          <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
      </div> -->
      <div class="vx-col md:w-1/4 w-full">
  <ul class="con-s w-full mt-4">
    <li>
      <label class="vs-input--label">{{ $t('ROLES.permissionLinkedToProfiles') }}</label>
      <vs-switch v-model="roleData.assignToProfile" disabled class="mt-2" />
    </li>
  </ul>
</div>
<div class="vx-col md:w-1/4 w-full">
  <ul class="con-s w-full mt-4">
    <li>
      <label class="vs-input--label">{{ $t('ROLES.usersCanEditLayout') }}</label>
      <vs-switch v-model="roleData.usersCanEditLayout" class="mt-2" />
    </li>
  </ul>
</div>
<div class="vx-col md:w-1/4">
  <div class="mt-4">
    <label class="vs-input--label">{{ $t('ROLES.allowedIPsList') }}</label>
    <v-select taggable multiple push-tags v-model="roleData.allowedHosts" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
  </div>
</div>
<div class="vx-col md:w-1/4">
  <div class="mt-4">
    <label class="vs-input--label">{{ $t('ROLES.blockedIPsList') }}</label>
    <v-select taggable multiple push-tags v-model="roleData.deniedHosts" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
  </div>
</div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <label class="vs-input--label">{{ $t('ROLES.MultipleLoginBehavior') }}</label>
          <v-select v-model="roleData.multipleLoginBehavior" :clearable="false" :options="multipleLoginBehaviorOptions" name="can_assign" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
        </div>
      </div>
      <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
          <label class="vs-input--label">{{ $t('ROLES.homeDisplayType') }}</label>
          <v-select v-model="roleData.homeViewType" :clearable="true" :options="homeViewTypeList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('status')">{{ errors.first('status') }}</span>
        </div>
      </div>
      <div class="vx-col md:w-1/4 w-full" v-show="showHomeViewData">
        <div class="mt-4">
          <label class="vs-input--label">{{ homeLabel }}</label>
          <v-select v-model="roleData.homeViewData" :clearable="false" :options="homeViewDataList" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
    </div>

    <div class="vx-row" v-show="roleData.assignToProfile">
      <div class="vx-col md:w-1/4 w-full">
        <div class="mt-4">
            <label class="text-sm">{{ $t('ROLES.profiles') }}</label>
            <v-select
            multiple
            label="name"
            v-model="roleData.profileData"
            :closeOnSelect="true"
            :options="profileOptions"
            name="profiles"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
             />
            <span class="text-danger text-sm"  v-show="errors.has('profiles')">{{ errors.first('profiles') }}</span>
        </div>
      </div>
    </div>

    <!-- Permissions -->
    <vx-card class="mt-base" no-shadow card-border v-show="!roleData.assignToProfile">

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">{{ $t('ROLES.permission') }}</span>
          </div>
          <div style="float: right!important;margin-top: -32px!important">
            <vs-button color="primary" type="filled" class="mr-4" @click="selectAll">{{ $t('ROLES.selectAll') }}</vs-button>
            <vs-button color="primary" type="filled" @click="unselectAll">{{ $t('ROLES.revokeAll') }}</vs-button>
          </div>
          <vs-divider />
        </div>
      </div>

      <div class="block overflow-x-auto">
        <vs-table class="w-full" :data="modules">
          <template slot="thead">
            <vs-th class="font-semibold text-base text-left px-3 py-2">{{ $t('ROLES.Module') }}</vs-th>
            <vs-th class="font-semibold text-base text-left px-3 py-2">{{ $t('ROLES.List') }}</vs-th>
            <vs-th class="font-semibold text-base text-left px-3 py-2">{{ $t('ROLES.View') }}</vs-th>
            <vs-th class="font-semibold text-base text-left px-3 py-2">{{ $t('ROLES.Create') }}</vs-th>
            <vs-th class="font-semibold text-base text-left px-3 py-2">{{ $t('ROLES.Edit') }}</vs-th>
            <vs-th class="font-semibold text-base text-left px-3 py-2">{{ $t('ROLES.Delete') }}</vs-th>
            <vs-th class="font-semibold text-base text-left px-3 py-2">{{ $t('ROLES.Import') }}</vs-th>
            <vs-th class="font-semibold text-base text-left px-3 py-2">{{ $t('ROLES.Export') }}</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="px-3 py-2" :data="tr.name">
                <div style="float: left;">
                  {{ tr.name }}
                </div>
              </vs-td>
              <vs-td class="px-3 py-2" :data="tr.username" >
                <div style="float: left;" @click="stopPropagationClick">
                  <vs-checkbox v-model="roleData.modulePermissions[tr.hash]['canList']" />
                </div>
              </vs-td>
              <vs-td class="px-3 py-2" :data="tr.username" >
                <div style="float: left;" @click="stopPropagationClick">
                  <vs-checkbox v-model="roleData.modulePermissions[tr.hash]['canView']" />
                </div>
              </vs-td>
              <vs-td class="text-left px-3 py-2" :data="tr.website">
                <div style="float: left;" @click="stopPropagationClick">
                  <vs-checkbox v-model="roleData.modulePermissions[tr.hash]['canCreate']"/>
                </div>
              </vs-td>
              <vs-td class="px-3 py-2" :data="tr.hash">
                <div style="float: left;" @click="stopPropagationClick">
                  <vs-checkbox v-model="roleData.modulePermissions[tr.hash]['canEdit']" />
                </div>
              </vs-td>
              <vs-td class="px-3 py-2" :data="tr.hash">
                <div style="float: left;" @click="stopPropagationClick">
                  <vs-checkbox v-model="roleData.modulePermissions[tr.hash]['canDelete']"/>
                </div>
              </vs-td>
              <vs-td class="px-3 py-2" :data="tr.hash">
                <div style="float: left;" @click="stopPropagationClick">
                  <vs-checkbox v-model="roleData.modulePermissions[tr.hash]['canImport']"/>
                </div>
              </vs-td>
              <vs-td class="px-3 py-2" :data="tr.hash">
                <div style="float: left;" @click="stopPropagationClick">
                  <vs-checkbox v-model="roleData.modulePermissions[tr.hash]['canExport']"/>
                </div>
              </vs-td>
                <template class="expand-user" slot="expand">
                  <div class="con-expand-users w-full">
                    <vx-card class="mt-base" no-shadow card-border>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <div class="flex items-end px-3">
                            <feather-icon svgClasses="w-6 h-6" icon="GridIcon" class="mr-2" />
                            <span class="font-medium text-lg leading-none">{{$t('ROLES.fields')}}</span>
                          </div>
                          <div style="float: right;">
                            <div style="float: left; margin-right: 12px;">
                              <div style="float: left; margin-right: 6px;">
                                <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-dark']" />
                              </div>
                              <div style="float: left;">
                                <span>{{$t('ROLES.Hidden')}}</span>
                              </div>
                            </div>
                            <div style="float: left; margin-right: 12px;">
                              <div style="float: left; margin-right: 6px;">
                                <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-warning']" />
                              </div>
                              <div style="float: left;">
                                <span>{{$t('ROLES.Readonly')}}</span>
                              </div>
                            </div>
                            <div style="float: left; margin-right: 12px;">
                              <div style="float: left; margin-right: 6px;">
                                <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4 text-success']" />
                              </div>
                              <div style="float: left;">
                                <span>{{ $t('ROLES.Written') }}</span>
                              </div>
                            </div>
                          </div>
                          <vs-divider />
                        </div>
                      </div>
                      <div class="block overflow-x-auto">
                        <vs-table :data="modules" stripe>
                          <template>
                            <vs-tr v-for="fieldRow in tr.organizedFields" :key="fieldRow.hash">
                              <vs-td v-for="field in fieldRow" :key="field.hash">
                                <label class="vs-input--label" style="font-size: 14px;">{{ field.title }}</label>
                                <div>
                                  <div>
                                    <vs-slider max="2" :color="initialColor[field.hash]" :id="`slider-${field.hash}`" :disabled="['assigned_to_id', 'assigned_to_id_multiple'].includes(field.name)" v-model="values[field.hash]" @input="sliderChange(`${field.hash}`, $event)" style="width: 8% !important; min-width: 0px !important; float: left;" />
                                  </div>
                                </div>
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </vx-card>
                  </div>
                </template>
            </vs-tr>
          </template>
        </vs-table>
      </div>

    </vx-card>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{ $t('ROLES.save') }}</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.push('/roles')">{{ $t('ROLES.cancel') }}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { setApplicationLocalStorageItem, performFetch } from '../../../helpers'

export default {
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {
      configdateTimePicker: {
        time_24hr: true,
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      roleData: {
        canAssignValue: { label: this.$t('MODULES.allUsers'),  value: 1 },
        canViewValue: { label: this.$t('MODULES.allUsers'),  value: 1 },
        name: '',
        respond_to: '',
        connectionStartTime: '00:00:00',
        connectionEndTime: '23:59:59',
        maxUserSimultaneousSessions: 10,
        maxRoleSessions: 10,
        allowedHosts: ['*'],
        deniedHosts: [],
        privileges: 1,
        usersCanEditLayout: false,
        multipleLoginBehavior: { label: this.$t('ROLES.dropActiveSession'), value: 1 },
        profileData: [],
        modulePermissions: {},
        assignToProfile: false,
        homeViewType: null,
        homeViewData: null
      },
      allFieldsData: {},
      selectOptions: {
        rolesOptions: []
      },
      homeViewTypeList: [
        { value: 1, label: this.$t('ROLES.module') },
        { value: 2, label: this.$t('ROLES.dashboard') },
        { value: 3, label: this.$t('ROLES.kanban') },
        { value: 4, label: this.$t('ROLES.calendar') },
        { value: 5, label: this.$t('ROLES.defaultHome') }
      ],
      showHomeViewData: false,
      homeLabel: '',
      homeViewDataList: [],
      modulesList: [],
      dashboardsList: [],
      kanbansList: [],
      calendarsList: [],
      profileOptions: [],
      showPermissionsTable: true,
      colorx:'#db7d12',
      values: {},
      isAdmin: false,
      role: {},
      initialColor: {},
      status: 1,
      canAssignOptions: [
        { label: this.$t('ROLES.allUsers'),  value: 1 },
        { label: this.$t('ROLES.sameRoleOrSubordinate'),  value: 2 },
        { label: 'Apenas cargo subordinado',  value: 3 }
      ],
      canViewOptions: [
        { label: this.$t('ROLES.allUsers'),  value: 1 },
        { label: this.$t('ROLES.sameRoleOrSubordinate'),  value: 2 },
        { label: this.$t('ROLES.userGroup'),  value: 3 },
        { label: this.$t('ROLES.userGroupAndSameRoleOrSubordinate'),  value: 4 },
        { label: this.$t('ROLES.onlyYourUser'),  value: 5 }
      ],
      multipleLoginBehaviorOptions: [
        { label: this.$t('ROLES.dropActiveSession'), value: 1},
        { label: this.$t('ROLES.KeepActiveSession'), value: 2}
      ],
      roleOptions: [],
      modules: []
    }
  },
  computed: {
    value1: {
      get () {
        return this.value1_local
      },
      set (obj) {

      }
    },
    status_local: {
      get () {
        return {
          label: this.status === 1 ? 'Ativo' : 'Inativo',
          value: this.status
        }
      },
      set (obj) {
        this.status = obj.value
      }
    },
    role_local: {
      get () {
        return {
          name: this.role.name,
          hash: this.role.hash
        }
      },
      set (obj) {
        this.role = obj
      }
    }
  },
  watch: {
    'roleData.homeViewType' (value) {
      if(value !== null && value.value !== 5) {

        switch(value.value) {
        case 1:

          this.homeLabel = this.$t('ROLES.SelectThe') + value.label
          this.showHomeViewData = true
          this.homeViewDataList = this.modulesList
          this.roleData.homeViewData = null

          break

        case 2:

          this.homeLabel = this.$t('ROLES.SelectThe') + value.label
          this.showHomeViewData = true
          this.homeViewDataList = this.dashboardsList
          this.roleData.homeViewData = null

          break

        case 3:

          this.homeLabel = this.$t('ROLES.SelectThe') + value.label
          this.showHomeViewData = true
          this.homeViewDataList = this.kanbansList
          this.roleData.homeViewData = null

          break

        case 4:

          this.homeLabel = this.$t('ROLES.SelectThe') + value.label
          this.showHomeViewData = false
          this.roleData.homeViewData = null

          break
        }
      } else {
        this.homeLabel = ''
        this.showHomeViewData = false
        this.roleData.homeViewData = null
      }
    }
  },
  mounted () {
    document.title = `${document.title.split(' | ')[0]  } | Cargos`
  },
  created () {
    this.initView()
  },
  methods: {
    selectAll() {

      this.$vs.loading({type: 'default'})

      const itemsList = []

      document.querySelectorAll('.td-check').forEach(item => {
        if(item.tagName.toLowerCase() === 'td' &&  item.classList.contains('active-expanded')) {
          item.click()
          itemsList.push(item)
        }
      })
      this.modules.forEach((item) => {
        item.fields.forEach((item) => {

          if(item.name === 'assigned_to_id_multiple') {
            this.values[item.hash] = 2
            this.initialColor[item.hash] = 'success'
          }

          if(!item.core) {
            this.values[item.hash] = 2
            this.initialColor[item.hash] = 'success'
          } else if(item.core && !['assigned_to_id', 'assigned_to_id_multiple'].includes(item.name)) {
            this.values[item.hash] = 1
            this.initialColor[item.hash] = 'warning'
          }
        })
      })
      Object.keys(this.roleData.modulePermissions).forEach((item) => {
        this.roleData.modulePermissions[item]['canCreate'] = true
        this.roleData.modulePermissions[item]['canDelete'] = true
        this.roleData.modulePermissions[item]['canDuplicate'] = true
        this.roleData.modulePermissions[item]['canEdit'] = true
        this.roleData.modulePermissions[item]['canExport'] = true
        this.roleData.modulePermissions[item]['canImport'] = true
        this.roleData.modulePermissions[item]['canList'] = true
        this.roleData.modulePermissions[item]['canView'] = true
      })

      setTimeout(() => {
        itemsList.forEach(item => item.click())

        this.$vs.loading.close()
      }, 300)
    },
    unselectAll() {

      this.$vs.loading({type: 'default'})

      const itemsList = []

      document.querySelectorAll('.td-check').forEach(item => {
        if(item.tagName.toLowerCase() === 'td' &&  item.classList.contains('active-expanded')) {
          item.click()
          itemsList.push(item)
        }
      })
      this.modules.forEach((item) => {
        item.fields.forEach((item) => {
          if(!['assigned_to_id', 'assigned_to_id_multiple'].includes(item.name)) {
            this.values[item.hash] = 0
            this.initialColor[item.hash] = 'dark'
          }
        })
      })
      Object.keys(this.roleData.modulePermissions).forEach((item) => {
        this.roleData.modulePermissions[item]['canCreate'] = false
        this.roleData.modulePermissions[item]['canDelete'] = false
        this.roleData.modulePermissions[item]['canDuplicate'] = true
        this.roleData.modulePermissions[item]['canEdit'] = false
        this.roleData.modulePermissions[item]['canExport'] = false
        this.roleData.modulePermissions[item]['canImport'] = false
        this.roleData.modulePermissions[item]['canList'] = false
        this.roleData.modulePermissions[item]['canView'] = false
      })

      setTimeout(() => {
        itemsList.forEach(item => item.click())

        this.$vs.loading.close()
      })
    },
    validateForm () {

      if (!this.roleData.name) {
        this.$vs.notify({
          title: this.$t('ROLES.Attention'),
          text: this.$t('ROLES.AlertStartTimeField', {field: this.$t('ROLES.Name')}),
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.roleData.respond_to) {
        this.$vs.notify({
          title: this.$t('ROLES.Attention'),
          text: this.$t('ROLES.AlertStartTimeField', {field: this.$t('ROLES.respondTo')}),
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.roleData.connectionStartTime) {
        this.$vs.notify({
          title: this.$t('ROLES.Attention'),
          text: this.$t('ROLES.AlertStartTimeField', {field: this.$t('ROLES.connectionStartTime')}),
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.roleData.connectionEndTime) {
        this.$vs.notify({
          title: this.$t('ROLES.Attention'),
          text: this.$t('ROLES.AlertStartTimeField', {field: this.$t('ROLES.connectionEndTime')}),
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.roleData.maxUserSimultaneousSessions) {
        this.$vs.notify({
          title: this.$t('ROLES.Attention'),
          text: this.$t('ROLES.AlertStartTimeField', {field: this.$t('ROLES.maxSessionsPerUser')}),
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (!this.roleData.maxRoleSessions) {
        this.$vs.notify({
          title: this.$t('ROLES.Attention'),
          text: this.$t('ROLES.AlertStartTimeField', {field: this.$t('ROLES.maxSessionsPerRole')}),
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if (this.roleData.assignToProfile && this.roleData.profileData.length === 0) {
        this.$vs.notify({
          title: this.$t('ROLES.Attention'),
          text: this.$t('ROLES.AlertStartTimeField', {field: this.$t('ROLES.profiles')}),
          iconPack: 'feather',
          icon: 'icon-icon-alert-circle',
          color: 'warning'
        })

        return false
      }

      if(this.roleData.homeViewType !== null) {

        if(this.roleData.homeViewType.value !== 4 && this.roleData.homeViewType.value !== 5) {
          if(this.roleData.homeViewData === null) {
            this.$vs.notify({
              title: this.$t('ROLES.Attention'),
              text: this.$t('ROLES.AlertStartTimeField', {field: this.$t(`ROLES.${this.homeLabel}`)}),
              iconPack: 'feather',
              icon: 'icon-icon-alert-circle',
              color: 'warning'
            })

            return false
          }
        }

      }

      return true
    },
    stopPropagationClick (e) {
      e.stopPropagation()
    },
    async initView () {
      this.$vs.loading({type: 'default'})
      // await fetch(this.$store.state.auth.api_url, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'get_application_role_parameters',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
        command: 'get_application_role_parameters',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then(async (response) => {
          this.$vs.loading.close()
          const roles = []
          const modules = []
          await response.json().then(async (responseData) => {
            responseData.parameters.roles.forEach((item) => {
              const role = {
                hash: item.hash,
                name: item.name
              }

              roles.push(role)
            })

            responseData.parameters.dashboards.forEach((item) => {
              this.dashboardsList.push(item)
            })

            responseData.parameters.modules.forEach((item) => {
              const module = {
                hash: item.hash,
                name: item.name
              }

              if(item.type_id === 2 || item.type_id === 3) {
                this.modulesList.push(JSON.parse(JSON.stringify(module)))
              } else if(item.type_id === 5) {
                this.calendarsList.push(JSON.parse(JSON.stringify(module)))
              } else if(item.type_id === 6) {
                this.kanbansList.push(JSON.parse(JSON.stringify(module)))
              }

              this.$set(this.roleData.modulePermissions, item.hash, {
                canList: false,
                canView: false,
                canCreate: false,
                canEdit: false,
                canDelete: false,
                canImport: false,
                canExport: false,
                canDuplicate: false
              })

              const data = []

              let i, j, temparray, chunk = 3

              for (i = 0, j = item.fields.length; i < j; i += chunk) {
                temparray = item.fields.slice(i, i + chunk)

                data.push(temparray)
              }

              module['organizedFields'] = data
              module['fields'] = item.fields

              item.fields.forEach((item) => {

                this.allFieldsData[item.hash] = item

                if (['assigned_to_id', 'assigned_to_id_multiple'].includes(item.name)) {
                  this.$set(this.values, item.hash, 2)
                  this.initialColor[item.hash] = 'success'
                } else {
                  this.$set(this.values, item.hash, 1)
                  this.initialColor[item.hash] = 'warning'
                }

              })

              modules.push(module)
            })

            this.selectOptions.rolesOptions = roles
            this.modules = modules
            this.profileOptions = responseData.parameters.profiles

          })

        })
        .catch((error) => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('ROLES.OperationNotCompleted'),
            text: this.$t('ROLES.ErrorLoadingParameters'),
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
        })
    },
    sliderChange (elementId, e) {

      if (e === 0) {
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-warning')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-success')
        document.querySelector(`#slider-${elementId}`).classList.add('vs-slider-dark')
      } else if (e === 1) {
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-dark')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-success')
        document.querySelector(`#slider-${elementId}`).classList.add('vs-slider-warning')
      } else if (this.allFieldsData[elementId]['core']) {
        setTimeout(() => {
          document.querySelector(`#slider-${elementId}`).children[0].querySelector('.vs-slider-line-one').classList.add('hasTransition')
          document.querySelector(`#slider-${elementId}`).children[0].querySelector('.vs-slider-line-one').style.width = '50%'
          document.querySelector(`#slider-${elementId}`).children[0].querySelector('.vs-slider-line-one').classList.remove('hasTransition')
          document.querySelector(`#slider-${elementId}`).children[0].querySelector('.vs-slider-line-efect').classList.add('run-effect')
          document.querySelector(`#slider-${elementId}`).children[0].querySelector('.vs-slider-line-efect').style.left = '50%'
          document.querySelector(`#slider-${elementId}`).children[0].querySelector('.vs-slider-line-efect').classList.remove('run-effect')
          document.querySelector(`#slider-${elementId}`).children[1].classList.add('hasTransition')
          document.querySelector(`#slider-${elementId}`).children[1].style.left = '50%'
          document.querySelector(`#slider-${elementId}`).children[1].classList.remove('hasTransition')
          if (document.querySelector('.vs-component.vs-notifications.vs-noti-bottom-right.vs-noti-warning.activeNoti') === null) {
            this.$vs.notify({
              title: this.$t('ROLES.Attention'),
              text: this.$t('ROLES.MaxPermissionForSystemFields'),
              iconPack: 'feather',
              icon: 'icon-icon-alert-circle',
              color: 'warning'
            })
          }
        }, 300)
        this.values[elementId] = 1
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-dark')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-success')
        document.querySelector(`#slider-${elementId}`).classList.add('vs-slider-warning')
      } else {
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-dark')
        document.querySelector(`#slider-${elementId}`).classList.remove('vs-slider-warning')
        document.querySelector(`#slider-${elementId}`).classList.add('vs-slider-success')
      }
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    async saveChanges () {
      /* eslint-disable */
      // if (!this.validateForm) return

      if(!this.validateForm()) return

      this.$vs.loading({type: 'default'})

      const permissionGroupModules = []

      if(!this.roleData.assignToProfile) {
        this.modules.forEach((item) => {

          const permissionGroupModuleFields = []

          item.fields.forEach((fieldItem) => {

            const permissionGroupModuleField = {
              hash: fieldItem.hash,
              visible: this.values[fieldItem.hash] >= 1 ? true : false,
              can_edit: this.values[fieldItem.hash] === 2 ? true : false
            }

            permissionGroupModuleFields.push(permissionGroupModuleField)
          })

          const permissionGroupModule = {
            hash: item.hash,
            list: this.roleData.modulePermissions[item.hash]['canList'],
            view: this.roleData.modulePermissions[item.hash]['canView'],
            create: this.roleData.modulePermissions[item.hash]['canCreate'],
            edit: this.roleData.modulePermissions[item.hash]['canEdit'],
            delete: this.roleData.modulePermissions[item.hash]['canDelete'],
            import: this.roleData.modulePermissions[item.hash]['canImport'],
            export: this.roleData.modulePermissions[item.hash]['canExport'],
            duplicate: this.roleData.modulePermissions[item.hash]['canDuplicate'],
            permission_group_module_fields: permissionGroupModuleFields
          }

          permissionGroupModules.push(permissionGroupModule)
        })
      }

      let homeViewTypeId = null
      let homeViewData = null

      if(this.roleData.homeViewType !== null) {
        homeViewTypeId = this.roleData.homeViewType.value
      }

      if(this.roleData.homeViewData !== null) {
        homeViewData = this.roleData.homeViewData.hash
      }

      // await fetch(this.$store.state.auth.api_url, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'add_application_role',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token,
      //       role: {
      //         name: this.roleData.name,
      //         can_assign_type_id: this.roleData.canAssignValue.value,
      //         can_view_type_id: this.roleData.canViewValue.value,
      //         reports_to_role_hash: this.roleData.respond_to.hash,
      //         connection_start_time: this.roleData.connectionStartTime,
      //         connection_end_time: this.roleData.connectionEndTime,
      //         max_user_simultaneous_sessions: parseInt(this.roleData.maxUserSimultaneousSessions),
      //         max_role_sessions: parseInt(this.roleData.maxRoleSessions),
      //         allowed_hosts: this.roleData.allowedHosts,
      //         denied_hosts: this.roleData.deniedHosts,
      //         block_multiple_logins_behavior_id: this.roleData.multipleLoginBehavior.value,
      //         users_can_edit_layout: this.roleData.usersCanEditLayout,
      //         assign_permissions_from_profile: this.roleData.assignToProfile,
      //         profiles: this.roleData.profileData,
      //         permission_group_modules: permissionGroupModules,
      //         home_view_type_id: homeViewTypeId,
      //         home_view_item_hash: homeViewData
      //       }
      //     },
      //   })
      // })
      await performFetch(this.$store.state.auth.api_url, {
          command: 'add_application_role',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            role: {
              name: this.roleData.name,
              can_assign_type_id: this.roleData.canAssignValue.value,
              can_view_type_id: this.roleData.canViewValue.value,
              reports_to_role_hash: this.roleData.respond_to.hash,
              connection_start_time: this.roleData.connectionStartTime,
              connection_end_time: this.roleData.connectionEndTime,
              max_user_simultaneous_sessions: parseInt(this.roleData.maxUserSimultaneousSessions),
              max_role_sessions: parseInt(this.roleData.maxRoleSessions),
              allowed_hosts: this.roleData.allowedHosts,
              denied_hosts: this.roleData.deniedHosts,
              block_multiple_logins_behavior_id: this.roleData.multipleLoginBehavior.value,
              users_can_edit_layout: this.roleData.usersCanEditLayout,
              assign_permissions_from_profile: this.roleData.assignToProfile,
              profiles: this.roleData.profileData,
              permission_group_modules: permissionGroupModules,
              home_view_type_id: homeViewTypeId,
              home_view_item_hash: homeViewData
            }
          },
        })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {

              this.$vs.loading.close()

              this.$vs.notify({
                title: this.$t('ROLES.OperationCompleted'),
                text: this.$t('ROLES.RoleAdded'),
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })

              this.$router.push('/roles')
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else if(response.status === 400) {
            response.json().then(responseData => {

              this.$vs.loading.close()

              if(responseData.message === 'Role Name Already Exists') {
                this.$vs.notify({
                  title: this.$t('ROLES.Attention'),
                  text: this.$t('ROLES.RoleAlreadyExists'),
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning'
                })

                return
              }
            })
          } else {
            this.$vs.notify({
              title: this.$t('ROLES.operationNotPerformed'),
              text: 'An error occurred while operation',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }
        })
        .catch((error) => {
          this.$vs.notify({
            title: this.$t('ROLES.operationNotPerformed'),
            text: 'An error occurred while registering the User',
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
        })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    update_avatar () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  }
}
</script>
<style>
.vs-con-tbody {
  border: none !important;
}

.vs-slider--circles.isEndValue {
  border-radius: 50%!important;
}
</style>
